import React, { Fragment, PureComponent } from 'react';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import { capfl } from 'common/utils';

import Select from 'common/components/styleguide/form/SelectCustom';
import TextIcon from 'common/components/styleguide/TextIcon';
import Button from 'common/components/styleguide/Button';
import Icon from 'common/components/styleguide/Icon';

import ProductDetailForm from './Form';

import {
  PRODUCT_DICOUNT_HOOK_TYPE,
  PRODUCT_SOFT_HOOK_TYPE
} from 'common/constants/ProductConstants';

import SS from 'common/components/product/_styles';
const S = {};

S.SelectWrapper = styled.div`
  display: flex;
`;

S.ButtonRemove = styled(Button)`
  margin-left: 5px;
`;

class Variants extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCombination: null,
      selected: []
    };
    this.removeSelected = this.removeSelected.bind(this);
  }
  getVariantsOptions(data) {
    const variantsOptions = [];
    _.each(data, item => {
      _.each(item.options, option => {
        const founded = _.find(
          variantsOptions,
          obj => obj.variantOptionId === option.variantOptionId
        );
        if (!founded) {
          variantsOptions.push({
            variantOptionId: option.variantOptionId,
            variantOptionName: option.variantOptionName
          });
        }
      });
    });
    return variantsOptions;
  }
  setSelected(newObj) {
    const newState = _.cloneDeep(this.state);
    const founded = _.find(newState.selected, obj => obj.id === _.toNumber(newObj.id));
    if (!founded) {
      newState.selected.push(newObj);
      this.setState(newState);
    } else {
      const filtredSelected = _.filter(newState.selected, obj => obj.id !== _.toNumber(newObj.id));
      newState.selected = filtredSelected;
      newState.selected.push(newObj);
      this.setState(newState);
    }
  }
  removeSelected(id) {
    const newState = _.cloneDeep(this.state);
    const filtredSelected = _.filter(newState.selected, obj => obj.id !== id);
    newState.selected = filtredSelected;
    this.setState(newState);
  }
  getVariantsCombinations(data, options, filter = []) {
    const variantsCombinations = {};
    _.each(data, variant => {
      const variantOptions = variant.options;
      const combination = [];
      _.each(options, option => {
        const variantOptionId = option.variantOptionId;
        const variantOptionName = option.variantOptionName;
        const founded = _.find(
          variantOptions,
          variantOption => _.toNumber(variantOption.variantOptionId) === _.toNumber(variantOptionId)
        );
        combination.push(
          founded
            ? {
                label: founded.value,
                id: founded.id,
                variantOptionName,
                variantOptionId
              }
            : {
                label: 'none',
                id: null,
                variantOptionName,
                variantOptionId
              }
        );
      });
      variantsCombinations[variant.variantProductId] = combination;
    });
    if (_.isArray(filter) && filter.length > 0) {
      const filterValues = _.map(filter, item => {
        return item.value;
      });
      const filteredVariantsCombinations = {};
      _.each(variantsCombinations, (combination, productId) => {
        const values = _.map(combination, item => item.label);
        if (_.difference(filterValues, values).length === 0) {
          filteredVariantsCombinations[productId] = combination;
        }
      });
      return filteredVariantsCombinations;
    }
    return variantsCombinations;
  }
  getSelects(variantsOptions, variantsCombinations) {
    let selects = [];
    _.each(variantsOptions, obj => {
      const { variantOptionName, variantOptionId } = obj;
      const selectBox = { variantOptionName, variantOptionId, options: [] };
      const possibleOptions = [];
      _.each(variantsCombinations, combination => {
        const found = _.find(combination, obj => obj.variantOptionId === variantOptionId);
        if (found) {
          possibleOptions.push({ id: found.id, label: found.label });
        }
      });
      selectBox.options = _.flow(
        arr => _.uniqBy(arr, 'label'),
        arr =>
          _.map(arr, obj => {
            const { id, label } = obj;
            return { value: id, label: label };
          })
      )(possibleOptions);
      selects.push(selectBox);
    });
    return selects;
  }
  render() {
    const { t, data } = this.props;
    const { selected } = this.state;
    const { variants, productHooks } = data;
    const variantsOptions = this.getVariantsOptions(variants);
    const variantsCombinations = this.getVariantsCombinations(variants, variantsOptions, selected);
    const selects = this.getSelects(variantsOptions, variantsCombinations);
    const productIds = _.keys(variantsCombinations);
    let selectedVariant = null;
    let selectedProduct = null;
    if (productIds.length === 1) {
      const productId = productIds[0];
      selectedVariant = _.find(variants, item => {
        const { product } = item;
        return product && product.id === _.toNumber(productId);
      });
      if (selectedVariant && selectedVariant.product) {
        selectedProduct = selectedVariant.product;
      }
    }
    const productHooksFiltred = _.filter(
      productHooks,
      hook => hook.type === PRODUCT_DICOUNT_HOOK_TYPE || hook.type === PRODUCT_SOFT_HOOK_TYPE
    );
    return (
      <Fragment>
        {_.map(selects, select => {
          const options = [].concat(
            [{ value: 0, label: capfl(t('choose option')) }],
            select.options
          );
          const selectVariantOptionId = select.variantOptionId;
          const selectedSelectOption = _.find(selected, obj => obj.id === selectVariantOptionId);
          return (
            <SS.Block key={'variant-select-' + select.variantOptionId}>
              <label>{capfl(select.variantOptionName)}</label>
              <S.SelectWrapper>
                <Select
                  options={options}
                  placeholder={capfl(t('choose option'))}
                  setValue={
                    selectedSelectOption
                      ? _.find(options, option => option.value === selectedSelectOption.value)
                      : _.head(options)
                  }
                  onChange={value => {
                    const valueN = _.toNumber(value);
                    const option = _.find(select.options, soption => soption.value === valueN);
                    if (option) {
                      this.setSelected({
                        id: select.variantOptionId,
                        value: option.label
                      });
                    } else {
                      this.removeSelected(select.variantOptionId);
                    }
                  }}
                />
                {selectedSelectOption ? (
                  <S.ButtonRemove
                    onClick={e => {
                      e.preventDefault();
                      this.removeSelected(select.variantOptionId);
                    }}
                  >
                    <Icon className="nc-simple-remove" />
                  </S.ButtonRemove>
                ) : (
                  ''
                )}
              </S.SelectWrapper>
            </SS.Block>
          );
        })}
        {selectedProduct ? (
          <ProductDetailForm data={selectedProduct} productHooks={productHooksFiltred} />
        ) : (
          <SS.Block>
            <TextIcon iconClassName="nc-ic_warning_18px">
              {capfl(t('please select variant'))}
            </TextIcon>
          </SS.Block>
        )}
      </Fragment>
    );
  }
}

export default withTranslation()(Variants);